import * as React from "react";
import { Autocomplete, TextField } from "@mui/material";

export default function AutoComplete(props) {
    const { listData, onChange, value, label, disabledValue = false, inputRef } = props;
    const keys = listData && listData.length > 0 ? Object.keys(listData[0]) : [];

    return (
        <Autocomplete
            options={listData}
            getOptionLabel={(option) => option[keys[1]] || ""}
            value={listData.find((item) => item[keys[0]] === value?.[keys[0]]) || null}
            onChange={(event, newValue) => {
                if (newValue) {
                    onChange({ [keys[0]]: newValue[keys[0]] });
                } else {
                    onChange(null);
                }
            }}
            disabled={disabledValue}
            renderInput={(params) => <TextField {...params} inputRef={inputRef} label={label} />}
            size="small"
            isOptionEqualToValue={(option, val) => option[keys[0]] === val[keys[0]]}
        />
    );
}
